import { useMemo } from 'react'
import { isDocumentTask } from '@ui/navigation/Navbar/components/RequestsWidget/documentTasks'
import useRunningTasks from '@ui/navigation/Navbar/components/RequestsWidget/useRunningTasks'

const hasDocumentTask = (tasks: RunningTask[]) => tasks.some(isDocumentTask)

// Document generation/preview tasks currently running for the project, oldest first.
// Polls faster while one is running so its progress stays current.
const useRunningDocumentTasks = (): RunningTask[] => {
  const { runningTasks } = useRunningTasks(hasDocumentTask)

  return useMemo(
    () =>
      runningTasks.filter(isDocumentTask).sort((a, b) => (a.started_at ?? 0) - (b.started_at ?? 0)),
    [runningTasks],
  )
}

export default useRunningDocumentTasks
